import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { applyDevSeedIfEmpty } from "./store/devSeed";

// Designer preview only - populates the registered profile panel with sample
// achievements + run history when the auth store is empty in DEV builds.
applyDevSeedIfEmpty();

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
